import { createFileRoute, Navigate } from '@tanstack/react-router';

// Redirect old analytics/reports to the new reporting center
export const Route = createFileRoute('/_authenticated/analytics/reports')({
  component: () => <Navigate to="/reports/history" replace />,
});
